import React from "react";

export function YearSelectorComponent({
                                 years, selectedYear, onSelectYear
                             }) {
    return (<>
        <div className={"d-flex flex-wrap justify-content-center gap-3"}>
        {
            years.map(
                (year, index) => (
                    <a key={index} onClick={() => onSelectYear(year)}
                       className={year === selectedYear ?
                           "btn btn-link-gradient btn-medium text-gradient-blue-yellow thin"
                           :
                           "btn btn-link underline-on-hover btn-medium text-dark-gray"}>
                        {year}
                        {year===selectedYear && <span className="bg-gradient-blue-yellow"></span>}</a>
                )
            )}
        </div>
    </>);
}